import React, { useState } from "react";

import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";
const sortActions = (x) => {
  if (x.indexOf("GET") > -1) return 0;
  if (x.indexOf("POST") > -1) return 1;
  if (x.indexOf("PUT") > -1) return 2;
  if (x.indexOf("ACTIVATE") > -1) return 3;
  if (x.indexOf("DELETE") > -1) return 4;
  return 5; // Unknown
};

const setLabel = (enty, perm) => {
  let entity = enty.value.charAt(0).toUpperCase() + enty.value.slice(1);

  let sortedPermissions = perm
    .map((item) => item.action.toUpperCase())
    .sort((a, b) => {
      var result = sortActions(a) - sortActions(b);
      if (result === 0) result = a.localeCompare(b);
      return result;
    });
  let permissions = sortedPermissions.map((item, key) =>
    item === "GET" ? (
      <span key={key} className="permission-badge get">
        {item + " "}
      </span>
    ) : item === "POST" ? (
      <span key={key} className="permission-badge post">
        {item + " "}
      </span>
    ) : item === "PUT" ? (
      <span key={key} className="permission-badge put">
        {item + " "}
      </span>
    ) : item === "ACTIVATE" ? (
      <span key={key} className="permission-badge activate">
        {item + " "}
      </span>
    ) : item === "DELETE" ? (
      <span key={key} className="permission-badge delete">
        {item + " "}
      </span>
    ) : (
      <span key={key} className="permission-badge">
        {item + " "}
      </span>
    )
  );

  return (
    <span>
      {entity} | <span>{permissions}</span>
    </span>
  );
};

const setBadge = (enty, perm) => {
  let key = enty.key;
  let lab = setLabel(enty, perm);
  return {
    id: key,
    name: lab,
  };
};

const convetToBadge = (objPermission) => {
  let aux = [];
  if (objPermission) {
    Object.keys(objPermission).map((enty) =>
      aux.push(
        setBadge(
          {
            key: enty,
            value: enty,
          },
          objPermission[enty].map((item) => ({
            value: item.id,
            action: item.action,
            description: item.description,
          })),
          true
        )
      )
    );
  }
  return aux;
};

const BadgesEllipsisRole = ({ objItems, sizePx, toBadge }) => {
  if (toBadge) {
    objItems = convetToBadge(objItems);
  }

  const [modal, setModal] = useState(false);

  const toggleModal = () => {
    setModal(!modal);
  };

  return (
    <React.Fragment>
      <div
        style={{
          width: sizePx,
        }}
      >
        {objItems.length > 2 ? (
          <div className="d-flex">
            {objItems.slice(0, 2).map((item, key) => (
              <div key={key} className="parent-badge-ellipsis d-inline-flex">
                <span className="badge-ellipsis font-size-12 mr-2 badge badge-dark">
                  {item.name}
                </span>
              </div>
            ))}
            <Dropdown
              className="d-inline-flex"
              // onClick={() => toggleModal()}
              onMouseEnter={() => toggleModal()}
              onMouseLeave={() => toggleModal()}
              isOpen={modal}
              nav={false}
              a11y={false}
            >
              <div className="d-inline-flex overflow-auto">
                <DropdownToggle
                  tag="span"
                  className="badge-ellipsis font-size-12 mr-2 badge badge-dark"
                >
                  +{objItems.length - 2}
                </DropdownToggle>
              </div>
              <DropdownMenu>
                {objItems.slice(2, objItems.length).map((item, key) => (
                  <div key={key} className="parent-badge-ellipsis d-flex">
                    <span
                      color="success"
                      className="badge-ellipsis-dropdown font-size-12 mx-2 my-1 badge badge-dark"
                    >
                      {item.name}
                    </span>
                  </div>
                ))}
              </DropdownMenu>
            </Dropdown>
          </div>
        ) : (
          <div className="d-flex">
            {objItems.map((item, key) => (
              <div key={key} className="parent-badge-ellipsis d-inline-flex">
                <span className="badge-ellipsis font-size-12 mr-2 badge badge-dark">
                  {item.name}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default BadgesEllipsisRole;
